import React from "react";
import StorePurchaseAccountsComp from "../../components/Store/StorePurchaseAccounts";

export default function StorePurchaseAccountsPage() {
  return <StorePurchaseAccountsComp />;
}
